import { memo } from "react";
import { NETS, C } from "@/lib/colors";

interface Props {
  net: string | null | undefined;
}

export const NetBadge = memo(function NetBadge({ net }: Props) {
  if (!net) return null;
  const info = NETS[net.toUpperCase()] ?? { sym: "●", c: C.text3 };
  return (
    <span
      title={net}
      className="inline-flex items-center font-mono-num transition-colors"
      style={{
        gap: 4,
        padding: "2px 8px",
        borderRadius: 4,
        background: `${info.c}1c`,
        border: `1px solid ${info.c}33`,
        fontSize: 10,
        fontWeight: 600,
        color: info.c,
      }}
    >
      <span style={{ opacity: 0.9 }}>{info.sym}</span>
      {net}
    </span>
  );
});
